import { createApp, Vue } from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import VueAxios from 'vue-axios';
import store from './store'
import VueTheMask from 'vue-the-mask'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'boxicons/css/boxicons.css';
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'


axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

axios.interceptors.request.use(async (config) => { 
    config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
    return config;
});


axios.interceptors.response.use((response) => {
  return Promise.resolve(response);
}, error => {
  console.log(error);
  if (
    error.response.status == 401
  ) {
    localStorage.removeItem('access_token');

    router.replace({
      path: "/login",
      query: { redirect: router.currentRoute.fullPath }
    });
  }
  return Promise.reject(error);
});

const api = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL
})

const app = createApp(App)

app.use(FloatingVue, {
  themes: {
    'info-tooltip': {
      $extend: 'tooltip',
      $resetCss: true,
    },
  },
})

app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "bottom-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
});
app.use(VueTheMask)
app.use(router)
app.use(store)
app.use(VueAxios, axios)
app.config.globalProperties.$axios = axios;
app.mount('#app');




// exemplo de uso de toast 

// import { useToast } from "vue-toastification";

// useToast().success("I'm a toast!");
